import React, { useCallback, useEffect, useState } from 'react'

import { useWallet } from 'use-wallet'
import useCvip from '../../hooks/useCvip'

import { bnToDec } from '../../utils'
import { getMasterChefContract, getEarned } from '../../cvip/utils'
import { getFarms } from '../../cvip/utils'

import Context from './context'
import { Farm } from './types'

const Farms: React.FC = ({ children }) => {
  const [unharvested, setUnharvested] = useState(0)

  const cvip = useCvip()
  const { account } = useWallet()

  const farms = getFarms(cvip)

  return (
    <Context.Provider
      value={{
        farms,
        unharvested,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default Farms
